import React from 'react'
import useRedirectParam from '@vero/ui-core-browser/hooks/redirect-param.js'
import Page from '@vero/ui-components/pages/page.jsx'
import CenteredWidget from '@vero/ui-components/components/centered-widget.jsx'
import Redirecting from '@vero/ui-components/components/redirecting.jsx'
import useClaims from '../hooks/claims.js'

export default function ({ title, Widget = undefined, children }) {
  const { redirect } = useRedirectParam()
  const { isLoggedIn } = useClaims()

  if (isLoggedIn()) {
    window.location.href = redirect

    return (
      <Page title={title}>
        <Redirecting className='auth-bg' />
      </Page>
    )
  }

  return (
    <Page title={title}>
      <CenteredWidget title={title} Widget={Widget} className='auth-bg'>
        {children}
      </CenteredWidget>
    </Page>
  )
}
